import React from 'react';
import styled, { css } from 'styled-components';

const HeaderStandard: React.FCC = ({ children }) => (
  <Container>{children}</Container>
);

const Container = styled.div<{}>(
  ({ theme }) => css`
    white-space: nowrap;
    display: flex;
    padding: ${theme.space('m')} ${theme.space('m')} 0 ${theme.space('m')};
  `,
);

export default HeaderStandard;
